import React from "react";

export function HeartFull({ className, style, width, height }) {
  return (
    <svg
      width={width || 40}
      height={height || 40}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={`tbk-min-w-0 tbk-shrink-0${className ? ` ${className}` : ""}`}
      style={style}
    >
      <path
        d="M20 36.3L4.4 21.5C2.4 19.6 1.3 16.9 1.3 14.2C1.3 11.4 2.4 8.8 4.4 6.8C6.3 4.8 9 3.7 11.7 3.7C14.5 3.7 17.2 4.8 19.1 6.8L20 7.7L20.9 6.8C22.9 4.8 25.5 3.7 28.3 3.7C31 3.7 33.7 4.8 35.6 6.8C37.6 8.8 38.7 11.4 38.7 14.2C38.7 16.9 37.6 19.6 35.6 21.5L20 36.3Z"
        fill="currentColor"
      />
    </svg>
  );
}
